@if (isOpen()) {
  <button class="sidebar-menu__backdrop" type="button" aria-label="Close menu" (click)="onClose()"></button>
}

<aside class="sidebar-menu" [class.sidebar-menu--open]="isOpen()" aria-label="Main menu">
  <div class="sidebar-menu__panel app-sidebar-surface">
    <div class="sidebar-menu__header">
      <div class="sidebar-menu__brand">
        <img
          class="app-brand-logo sidebar-menu__brand-logo"
          src="images/juno-audit-mark.png"
          alt=""
          aria-hidden="true"
          width="34"
          height="28"
        />
        <div class="app-sidebar-title">{{ appName() }}</div>
      </div>

      <button class="app-icon-button app-icon-button--sidebar" type="button" aria-label="Close menu" (click)="onClose()">
        <span class="fa-solid fa-xmark" aria-hidden="true"></span>
      </button>
    </div>

    <nav class="sidebar-menu__nav app-sidebar-nav" aria-label="Primary">
      <div class="sidebar-menu__items">
        @for (item of visibleMainItems(); track item.id) {
          <button
            class="app-sidebar-nav__item"
            [class.app-sidebar-nav__item--active]="item.id === activeItemId()"
            type="button"
            (click)="onItemSelected(item.id)"
          >
            <span class="app-sidebar-nav__icon" aria-hidden="true">
              <span [class]="item.iconClass"></span>
            </span>
            <span>{{ i18n.t(item.labelKey) }}</span>
          </button>
        }
      </div>

      @if (visibleActionItems().length > 0) {
        <div class="sidebar-menu__actions">
          <div class="sidebar-menu__section-title">{{ i18n.t('sidebar.section.actions') }}</div>

          @for (item of visibleActionItems(); track item.id) {
            <button
              class="app-sidebar-nav__item"
              type="button"
              (click)="onActionSelected(item.id)"
            >
              <span class="app-sidebar-nav__icon" aria-hidden="true">
                <span [class]="item.iconClass"></span>
              </span>
              <span>{{ i18n.t(item.labelKey) }}</span>
            </button>
          }
        </div>
      }
    </nav>
  </div>
</aside>
